<h6 class="mb-3 fw-bolder">{{'ACCESSIBLE_MENU' | translate}}</h6>

<ul class="list-unstyled">
  <li *ngFor="let item of filterSidebarMenu" class="">
    <ng-container *ngIf="item.type === 'header'">
      <div class="item__header">
        {{ item.name | translate }}
      </div>
    </ng-container>
    <ng-container *ngIf="item.type === 'menu'" class="">
      <div class="item__menu">
        <ng-container *ngIf="!item.imageSrc">
          <i [class]="'fix-icon ' + item.iconClass"> {{ item.iconName }} </i>
        </ng-container>
        <ng-container *ngIf="item.imageSrc">
          <img class="item__image rounded-circle" [src]="item.imageSrc" alt="" />
        </ng-container>
        {{ item.name | translate }} <i class="bi bi-chevron-down"></i>
      </div>

      <ul class="list-unstyled mb-2">
        <li *ngFor="let sub of item.menuList" class="">
          <div class="item__sub">
            <i class="far fa-circle fa-xs" style="width: 12px"></i>
            {{ sub.name | translate }}
          </div>
        </li>
      </ul>
    </ng-container>
    <ng-container *ngIf="item.type === 'router'" class="">
      <div class="item__router">
        <ng-container *ngIf="!item.imageSrc">
          <i [class]="'fix-icon ' + item.iconClass"> {{ item.iconName }} </i>
        </ng-container>
        <ng-container *ngIf="item.imageSrc">
          <img class="item__image rounded-circle" [src]="item.imageSrc" alt="" />
        </ng-container>

        {{ item.name | translate }}
      </div>
    </ng-container>
  </li>
  <li *ngIf="roles.length === 0" class="text-center text-secondary">
    <i class="bi bi-exclamation-triangle"></i> {{'NO_ACCESS_RIGHTS' | translate}}
  </li>
  <li *ngIf="roles.length > 0 && filterSidebarMenu.length === 0" class="text-center text-warning">
    <i class="bi bi-exclamation-triangle"></i> {{'NO_MENU_AVAILABLE' | translate}}
  </li>
</ul>
